





































import { computed, defineComponent, onMounted, ref, useContext, useRouter } from '@nuxtjs/composition-api'
import Offers from '~/components/solepro/MyAccount/Offers.vue';
import Wishlist from '~/components/solepro/MyAccount/Wishlist.vue';
import { useConfig, useUser } from '~/composables';
import { areaUtenteProfile } from '~/utils/constants/hosts';
import Notification from '~/components/Notification.vue';
import ClientOnly from 'vue-client-only';
import { getUserIsLogged } from '~/helpers/user/user';

enum VIEWS {
    WISHLIST = 'WISHLIST',
    OFFERS = 'OFFERS',
}
enum VIEWS_TITLES {
    WISHLIST = 'Preferiti',
    OFFERS = 'Offerte',
}
export default defineComponent({
    components: { Wishlist, Offers, Notification, ClientOnly },
    setup() {
        const { config } = useConfig();
        const { $cookies } = useContext();
        const currentView = ref(VIEWS.WISHLIST);
        const storeCode = computed(() => config.value?.store_code);
        const allowView = computed(() => getUserIsLogged($cookies));
        const { logout } = useUser()
        const router = useRouter()
        onMounted(() => {
            if (!allowView.value) {
                location.href = `/${storeCode.value}`;
            } else if (window.innerWidth < 1024) {
                currentView.value = null;
            }
        })
        const homePath =router.resolve({ path: `/${storeCode.value}` })
        return {
            storeCode,
            currentView,
            VIEWS,
            VIEWS_TITLES,
            areaUtenteProfile,
            allowView,
            homePath,
            logout: ()=>{logout({}, $cookies, ()=>location.href = homePath.href)}
        }
    },
    watch: {
        allowView(newVal) {
            if (!newVal) {
                location.href = this.homePath.href
            }
        }
    },
    methods: {
        changeView(view: VIEWS) {
            this.currentView = view;
        }
    }
})
